<script setup lang="ts">
import {
  ROOT_CATALOG_URL,
  ROOT_JOURNAL_URL,
  ROOT_EDITORS_STAFF_URL,
  ROOT_LAWYERS_PAGE_URL,
  ROOT_PARTNER_PROGRAM_URL,
} from '@/shared/constants/urlConstants';

import {
  PHONE_NUMBER,
  COMPANY_EMAIL,
  COMPANY_TELEGRAM_LINK,
  COMPANY_VK_LINK,
} from '@/shared/constants/contactConstants';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <nav :class="['footer-nav', { _mobile: isMobile }]">
    <div class="footer-nav__items">
      <div class="footer-nav__item _top">
        <span class="footer-nav__title">Клиентам</span>
        <ul class="footer-nav__list">
          <li class="footer-nav__list-item">
            <NuxtLink
              :to="ROOT_CATALOG_URL"
              class="footer-nav__link"
              active-class=""
              exact-active-class=""
            >
              Каталог юристов
            </NuxtLink>
          </li>
          <li class="footer-nav__list-item">
            <NuxtLink
              :to="ROOT_JOURNAL_URL"
              class="footer-nav__link"
              active-class=""
              exact-active-class=""
            >
              Журнал
            </NuxtLink>
          </li>
          <li class="footer-nav__list-item">
            <NuxtLink
              :to="ROOT_EDITORS_STAFF_URL"
              class="footer-nav__link"
              active-class=""
              exact-active-class=""
            >
              Редакция
            </NuxtLink>
          </li>
        </ul>
      </div>
      <div class="footer-nav__item _top">
        <span class="footer-nav__title">Сотрудничество</span>
        <ul class="footer-nav__list">
          <li class="footer-nav__list-item">
            <NuxtLink
              :to="ROOT_LAWYERS_PAGE_URL"
              class="footer-nav__link"
              active-class=""
              exact-active-class=""
            >
              Клиенты юристам
            </NuxtLink>
          </li>
          <li class="footer-nav__list-item">
            <a
              class="footer-nav__link _partner"
              :href="ROOT_PARTNER_PROGRAM_URL"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Партнерская программа"
            >
              Партнерская программа
              <AppIcon class="footer-nav__icon _partner" name="Link" />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-nav__item">
      <span class="footer-nav__title">Контакты</span>
      <ul class="footer-nav__list">
        <li class="footer-nav__list-item _contacts">
          Позвоните нам:
          <a
            class="footer-nav__link _contacts"
            :href="`tel:${PHONE_NUMBER}`"
            rel="noopener noreferrer"
            :aria-label="`${PHONE_NUMBER}, позвонить нам`"
          >
            {{ PHONE_NUMBER }}
          </a>
        </li>
        <li class="footer-nav__list-item _contacts">
          Напишите нам:
          <a
            class="footer-nav__link _contacts"
            :href="`mailto:${COMPANY_EMAIL}`"
            rel="noopener noreferrer"
            :aria-label="`${COMPANY_EMAIL}, написать нам`"
          >
            {{ COMPANY_EMAIL }}
          </a>
        </li>
        <li class="footer-nav__list-item">
          <a
            class="footer-nav__link _social"
            :href="`${COMPANY_TELEGRAM_LINK}`"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Написать в Telegram"
          >
            <span
              style="
                width: 0;
                opacity: 0;
                height: 0;
                margin: -1px;
                pointer-events: none;
                display: inline-block;
              "
              >tg</span
            >
            <AppIcon
              class="footer-nav__icon"
              name="TelegramWhite"
              width="20px"
              height="20px"
            />
          </a>
          <a
            class="footer-nav__link _social"
            :href="`${COMPANY_VK_LINK}`"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Написать в ВК"
          >
            <span
              style="
                width: 0;
                opacity: 0;
                height: 0;
                margin: -1px;
                pointer-events: none;
                display: inline-block;
              "
              >vk</span
            >
            <AppIcon class="footer-nav__icon" name="VkWhite" width="20px" height="20px" />
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<style lang="less">
.footer-nav {
  display: flex;
  gap: 80px;
  white-space: nowrap;

  &__items {
    display: flex;
    gap: 80px;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: white;
    position: relative;
    padding-bottom: 6px;

    &::after {
      content: '';
      position: absolute;
      width: 38px;
      background-color: @color-persimmon;
      height: 1px;
      left: 0;
      bottom: 1px;
    }
  }

  &__list {
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.3px;
  }

  &__list-item {
    color: white;
    margin-top: 10px;
  }

  &__link {
    .color-change-hover();

    color: white;

    &._contacts {
      font-weight: 600;
      margin-left: @main-size;
    }

    &._social {
      &:not(:last-child) {
        margin-right: @size-x3;
      }
    }

    &._partner {
      display: flex;
      align-items: center;
      gap: @main-size;

      .footer-nav__icon._partner path {
        transition: fill @A ease-in-out;
      }

      &:hover .footer-nav__icon._partner path {
        fill: @color-persimmon;
      }
    }
  }

  &__button {
  }

  &__icon {
    &._partner {
      width: @size-x3;
      height: @size-x3;
    }

    &:hover {
      path {
        fill: @color-flame-pea;
      }

      circle {
        stroke: @color-flame-pea;
      }
    }
  }

  &._mobile {
    gap: @size-x8;
    flex-direction: column;
  }

  &._mobile &__list {
    font-size: @size-x3;
  }

  &._mobile &__items {
    gap: @size-x7;
  }
}
</style>
